module.exports = "#productLinksDiv a {\n  margin-left: 30px;\n  color: #918b84;\n}"